import React from 'react';
import {
  BackgroundColorWrap,
  CTAWrapper,
  MainContainer,
  PricingBarWrapper,
} from './PricingBar.styles';
import VinAudiCode from '../VinAudiCode';
import PriceInfoT3 from '../DealerPriceInfo/PriceInfo-T3';
import PriceInfoT1 from '../DealerPriceInfo/PriceInfo-T1';
import CTASection from '../CTASection/index';
import type { StockCarType } from '../../types/oneGraphTypes';
import { VendorCTATypes } from '../../types';
import { SinglePriceConfigType } from '../../types/SinglePriceContent';
import VendorCTAsGroup from '../VendorCTAsGroup/VendorCTAsGroup';
import StickyNavBar from '../StickyNavbar';
// import useStaticVehicleData from '../../hooks/useStaticVehicleData';

export interface PricingBarProps {
  isTier3: boolean;
  market: string;
  vehicle: StockCarType | null;
  loading: boolean;
  tier3Ctas: VendorCTATypes;
  priceConfig: SinglePriceConfigType;
  rapidName: string;
}

const PricingBar: React.FC<PricingBarProps> = ({
  isTier3,
  market,
  vehicle,
  loading,
  tier3Ctas,
  priceConfig,
  rapidName,
}) => {
  if (!vehicle) return null;

  const { vin, id, dealer, cartypeText, carPrices, commissionNumber, dynamicAttributes } = vehicle;
  const modelYear = vehicle.model?.salesModelyear;
  const weblink = vehicle.weblink ?? '';
  const audiCode = vehicle.code?.id ?? '';
  const isAvailableNow = vehicle.salesInfo?.availableFromDateInfo?.value === 'Immediately';
  const genericModelCode = vehicle.modelInfo?.genericModel?.code ?? '';
  const modelMake = genericModelCode ? genericModelCode.substring(0, 2) : '';
  // OADD Stock Number
  const oaddStockNumber = dynamicAttributes?.find((key) => key.id === 'VEHICLE_ID')?.value ?? '';

  const isMarketUSA = market.includes('us');
  const { vendorCtaGroup } = tier3Ctas;

  const digitalLeadsData = JSON.stringify({
    vehicleType: cartypeText === 'N' ? 'new' : 'used',
    market,
    presetForm: 'contact-dealer',
    dealerId: dealer?.id?.slice(3) ?? '',
  });

  return (
    <>
      <BackgroundColorWrap>
        <PricingBarWrapper>
          <MainContainer data-testid="dealer-list-price-container">
            {isTier3 ? (
              <PriceInfoT3
                priceConfig={priceConfig}
                carPrices={carPrices ?? []}
                carType={cartypeText}
              />
            ) : (
              <PriceInfoT1
                carPrices={carPrices ?? []}
                carType={cartypeText}
                market={market}
                isAvailableNow={isAvailableNow}
                modelYear={modelYear || 2025}
              />
            )}

            <CTAWrapper>
              <VinAudiCode vin={vin} oaddStockNumber={oaddStockNumber} modelMake={modelMake} />
              {isTier3 ? (
                <VendorCTAsGroup
                  ctas={vendorCtaGroup}
                  vin={vin}
                  vehicleId={id}
                  market={market}
                  vehicleData={vehicle}
                  cartypeText={cartypeText}
                />
              ) : (
                <CTASection
                  isSticky={false}
                  isMarketUSA={isMarketUSA}
                  digitalLeadsData={digitalLeadsData}
                  weblink={weblink}
                  carType={cartypeText}
                  kvpsSyncId={dealer?.id?.slice(3)}
                  market={market}
                  stockNumber={commissionNumber}
                  modelYear={modelYear || 2025}
                  vehicleId={id}
                  audiCode={audiCode}
                  rapidName={rapidName}
                  isAvailableNow={isAvailableNow}
                />
              )}
            </CTAWrapper>
          </MainContainer>
        </PricingBarWrapper>
      </BackgroundColorWrap>
      {!isTier3 && (
        <StickyNavBar
          digitalLeadsData={digitalLeadsData}
          vehicle={vehicle}
          market={market}
          modelYear={modelYear}
          rapidName={rapidName}
        />
      )}
    </>
  );
};

export default PricingBar;
